module.exports = __webpack_public_path__ + "static/tray-io-50f64f6c38850affde3638e3d2d7a618.svg";